import { Interaction } from '../apis';
import {
  InteractionImportance,
  InteractionQuality,
  TrackingData,
} from '../types';
import { elementPathToString } from './element-id';

export type InteractionPayload = {
  path: string;
  type: Interaction['type'];
  action?: string;
  data: TrackingData;
  quality?: InteractionQuality;
  importance?: InteractionImportance;
  sourceAnchor: string;
};

export const toInteractionPayload = (
  interaction: Interaction,
): InteractionPayload => ({
  path: elementPathToString(interaction.elementPath),
  type: interaction.type,
  ...(interaction.action ? { action: interaction.action } : {}),
  data: interaction.data,
  ...(interaction.quality && interaction.quality !== 'declared'
    ? { quality: interaction.quality }
    : {}),
  ...(interaction.importance ? { importance: interaction.importance } : {}),
  sourceAnchor: interaction.sourceAnchor ?? '',
});
